import { FilterAlt, TextFields, Visibility } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { CustomIconButton } from "../../shared/CustomIconButton";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
// import Button from '@mui/material/Button';
import Tooltip from "@mui/material/Tooltip";
import sync from "../../assets/sync.png";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import LockIcon from "@mui/icons-material/Lock";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const StoreDataMapping = () => {
  const [data, setData] = useState([]);
  const [syncData, setSyncData] = useState(false);
  const [syncData1, setSyncData1] = useState(false);
  const [syncData2, setSyncData2] = useState(false);
  const [syncData3, setSyncData3] = useState(false);
  const [syncData4, setSyncData4] = useState(false);

  const [syncFail, setSyncFail] = useState("");
  const [syncFail1, setSyncFail1] = useState("");
  const [syncFail2, setSyncFail2] = useState("");
  const [syncFail3, setSyncFail3] = useState("");
  const [syncFail4, setSyncFail4] = useState("");

  const [successData, setSuccessData] = useState([]);
  const [successData1, setSuccessData1] = useState([]);
  const [successData2, setSuccessData2] = useState([]);
  const [successData3, setSuccessData3] = useState([]);
  const [successData4, setSuccessData4] = useState([]);

  const [storeId, setStoreId] = useState(12);
  const [storeData, setStoreData] = useState([]);

  const storeDataList = () => {
    axiosInstance
      .get(`api/admin/multivendor-show-store-list/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setStoreData(response?.data?.vendor_store_list);
        console.log("store data list==>", response?.data?.vendor_store_list);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };
  useEffect(() => {
    storeDataList();
  }, []);

  function saveSyncData() {
    setSyncData(true);
    axiosInstance
      .get(`api/admin/sync-business-type-data-from-erp/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("business sync data list==>");
        if (
          response?.data.message ===
          "Failed to retrieve business type data: Failed to parse: http://192.168.1.71:9093.cronjob/sync-business-type-details/"
        ) {
          setSyncFail(response?.data.message);
          setSyncData(false);
        } else if (response?.data.message === "Data Synced successfully") {
          toast.success(response?.data.message);
          setSyncData(false);
          console.log(response?.data);
          setSuccessData(response?.data);
        }
      })
      .catch((error) => {
        toast.error("!oops Network Error", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.log("", error.response);
        console.log(error);
        setSyncData(false);
      });
  }
  function saveSyncData1() {
    setSyncData1(true);
    axiosInstance
      .get(`api/admin/sync-business-sub-type-data-from-erp/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("business sync data list==>");
        if (
          response?.data.message ===
          "Failed to retrieve business type data: Failed to parse: http://192.168.1.71:9093.cronjob/sync-business-type-details/"
        ) {
          setSyncFail1(response?.data.message);
          setSyncData1(false);
        } else if (response?.data.message === "Data Synced successfully") {
          toast.success(response?.data.message);
          setSyncData1(false);
          setSuccessData1(response?.data);
        }
      })
      .catch((error) => {
        toast.error("!oops Network Error", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.log("", error.response);
        console.log(error);
        setSyncData1(false);
      });
  }

  function saveSyncData2() {
    setSyncData2(true);
    axiosInstance
      .get(`api/admin/map-store-main-category/?store_id=${storeId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("business sync data list==>");
        if (
          response?.data.message ===
          "Failed to retrieve business type data: Failed to parse: http://192.168.1.71:9093.cronjob/sync-business-type-details/"
        ) {
          setSyncFail2(response?.data.message);
          setSyncData2(false);
        } else if (response?.data.message === "Data Synced successfully") {
          toast.success(response?.data.message);
          setSuccessData2(response?.data);
          setSyncData2(false);
        }
      })
      .catch((error) => {
        toast.error("!oops Network Error", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.log("", error.response);
        console.log(error);
        setSyncData2(false);
      });
  }
  function saveSyncData3() {
    setSyncData3(true);
    axiosInstance
      .get(`api/admin/map-store-sub-category/?store_id=${storeId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("business sync data list==>");
        if (
          response?.data.message ===
          "Failed to retrieve business type data: Failed to parse: http://192.168.1.71:9093.cronjob/sync-business-type-details/"
        ) {
          setSyncFail3(response?.data.message);
          setSyncData3(false);
        } else if (response?.data.message === "Data Synced successfully") {
          toast.success(response?.data.message);
          setSyncData3(false);
          setSuccessData3(response?.data);
        }
      })
      .catch((error) => {
        toast.error("!oops Network Error", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.log("", error.response);
        console.log(error);
        setSyncData3(false);
      });
  }
  function saveSyncData4() {
    setSyncData4(true);
    axiosInstance
      .get(`api/admin/map-store-brand/?store_id=${storeId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("business sync data list==>");
        if (
          response?.data.message ===
          "Failed to retrieve business type data: Failed to parse: http://192.168.1.71:9093.cronjob/sync-business-type-details/"
        ) {
          setSyncFail4(response?.data.message);
          setSyncData4(false);
        } else if (response?.data.message === "Data Synced successfully") {
          toast.success(response?.data.message);
          setSyncData4(false);
          setSuccessData4(response?.data);
        }
      })
      .catch((error) => {
        toast.error("!oops Network Error", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.log("", error.response);
        console.log(error);
        setSyncData4(false);
      });
  }

  //   const BusinessDataList = () => {
  //     axios
  //       .post(
  //         `https://app1.crazzyhub.com/api/admin/multivendor-business-category-list-data/`,
  //         {},
  //         {
  //           headers: {
  //             Token: localStorage.getItem("Token"),
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         setBusinessData(response?.data?.business_category_list_data);
  //       })
  //       .catch((error) => {
  //         console.log("", error.response);
  //         console.log(error);
  //       });
  //   };
  //   useEffect(() => {
  //     BusinessDataList();
  //   }, []);

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            <p className="text-xl text-black font-bold">Sync Management</p>
            {/* <p className="text-black">View/Search Delivery Management</p> */}
          </div>

          <div className="m-4 gap-x-3">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                select store
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size="small"
                label="select store"
                className="w-72"
                value={storeId}
                onChange={(event) => setStoreId(event.target.value)}
              >
                {storeData?.map((elem) => (
                  <MenuItem value={elem?.id}>{elem?.store_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <hr />
        <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2">
          <div className="flex justify-between">
            <div className="flex">
              <div
                style={{
                  borderRight: "1px solid #D0D0D0",

                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-gray-800 p-3 w-40 !font-bold"
              >
                Category & Sub Category
              </div>
              <div>
                {syncData2 ? (
                  <div
                    className="m-2 w-32 flex justify-between "
                    style={{
                      borderRight: "2px solid #D0D0D0",

                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    <span className="pt-1 text-green-600 font-bold">
                      Sync Data :{" "}
                    </span>{" "}
                    <img src={sync} className="h-8 animate-spin" />
                  </div>
                ) : (
                  <div className="m-2 w-32 flex justify-between">
                    <span className="pt-1 text-green-600 font-bold">
                      Sync Data :{" "}
                    </span>{" "}
                    <img
                      src={sync}
                      className="h-8 w-8"
                      onClick={saveSyncData2}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="p-3 border-l border-gray-300">{syncFail}</div>
            {/* <div className="w-96 !float-right bg-gray-200 shadow-sm shadow-blue-500">
              <div className="flex justify-between p-1 text-black">
                <div className="border-r text-sm text-green-600">
                  Sync Data Count
                </div>
                <div className="text-sm text-blue-500">Elapsed Time</div>
              </div>
              <div className="flex p-1 text-black">
                <div className="border-r text-sm text-center w-[50%]">
                  {successData?.synced_data_count}
                </div>
                <div className=" text-[12px] text-right w-[50%]">
                  {successData?.elapsed_time}
                </div>
              </div>
            </div> */}
            <div className="w-96 !float-right bg-gray-200 shadow-sm shadow-blue-500">
              <div className="text-gray-700 underline underline-offset-4 font-bold p-1 text-center">
                Category Details :
              </div>
              <div className="flex justify-between p-1 text-black">
                <div className="border-r text-sm text-green-600">
                  Create Data Count
                </div>
                <div className="border-r text-sm text-green-600">
                  Update Data Count
                </div>
                <div className="text-sm text-blue-500">Elapsed Time</div>
              </div>
              <div className="flex p-1 text-black">
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.created_data_count}
                </div>
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.updated_data_count}
                </div>
                <div className=" text-[12px] text-right w-[50%]">
                  {successData2?.elapsed_time}
                </div>
              </div>
            </div>
            <div className="w-96 !float-right bg-gray-200 shadow-sm shadow-blue-500">
              <div className="text-gray-700 underline underline-offset-4 font-bold p-1 text-center">
                Sub Category Details :
              </div>
              <div className="flex justify-between p-1 text-black">
                <div className="border-r text-sm text-green-600">
                  Create Data Count
                </div>
                <div className="border-r text-sm text-green-600">
                  Update Data Count
                </div>
                <div className="text-sm text-blue-500">Elapsed Time</div>
              </div>
              <div className="flex p-1 text-black">
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.sub_created_data_count}
                </div>
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.sub_updated_data_count}
                </div>
                <div className=" text-[12px] text-right w-[50%]">
                  {successData2?.elapsed_time}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2">
          <div className="flex justify-between">
            <div className="flex">
              <div
                style={{
                  borderRight: "1px solid #D0D0D0",

                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-gray-800 p-3 w-40 !font-bold"
              >
                Sub Category
              </div>
              <div>
                {syncData3 ? (
                  <div
                    className="m-2 w-32 flex justify-between "
                    style={{
                      borderRight: "2px solid #D0D0D0",

                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    <span className="pt-1 text-green-600 font-bold">
                      Sync Data :{" "}
                    </span>{" "}
                    <img src={sync} className="h-8 animate-spin" />
                  </div>
                ) : (
                  <div className="m-2 w-32 flex justify-between">
                    <span className="pt-1 text-green-600 font-bold">
                      Sync Data :{" "}
                    </span>{" "}
                    <img
                      src={sync}
                      className="h-8 w-8"
                      onClick={saveSyncData3}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="p-3 border-l border-gray-300">{syncFail}</div>
            <div className="w-96 !float-right bg-gray-200 shadow-sm shadow-blue-500">
              <div className="flex justify-between p-1 text-black">
                <div className="border-r text-sm text-green-600">
                  Create Data Count
                </div>
                <div className="border-r text-sm text-green-600">
                  Update Data Count
                </div>
                <div className="text-sm text-blue-500">Elapsed Time</div>
              </div>
              <div className="flex p-1 text-black">
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.created_data_count}
                </div>
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.updated_data_count}
                </div>
                <div className=" text-[12px] text-right w-[50%]">
                  {successData2?.elapsed_time}
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2">
          <div className="flex justify-between">
            <div className="flex">
              <div
                style={{
                  borderRight: "1px solid #D0D0D0",

                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-gray-800 p-3 w-40 !font-bold"
              >
                brand
              </div>
              <div>
                {syncData4 ? (
                  <div
                    className="m-2 w-32 flex justify-between "
                    style={{
                      borderRight: "2px solid #D0D0D0",

                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    <span className="pt-1 text-green-600 font-bold">
                      Sync Data :{" "}
                    </span>{" "}
                    <img src={sync} className="h-8 animate-spin" />
                  </div>
                ) : (
                  <div className="m-2 w-32 flex justify-between">
                    <span className="pt-1 text-green-600 font-bold">
                      Sync Data :{" "}
                    </span>{" "}
                    <img
                      src={sync}
                      className="h-8 w-8"
                      onClick={saveSyncData4}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="p-3 border-l border-gray-300">{syncFail}</div>
            {/* <div className="w-96 !float-right bg-gray-200 shadow-sm shadow-blue-500">
              <div className="flex justify-between p-1 text-black">
                <div className="border-r text-sm text-green-600">
                  Sync Data Count
                </div>
                <div className="text-sm text-blue-500">Elapsed Time</div>
              </div>
              <div className="flex p-1 text-black">
                <div className="border-r text-sm text-center w-[50%]">
                  {successData?.synced_data_count}
                </div>
                <div className=" text-[12px] text-right w-[50%]">
                  {successData?.elapsed_time}
                </div>
              </div>
            </div> */}
            <div className="w-96 !float-right bg-gray-200 shadow-sm shadow-blue-500">
              {/* <div className="text-gray-700 underline underline-offset-4 font-bold p-1 text-center">Sub Category Details :</div> */}
              <div className="flex justify-between p-1 text-black">
                <div className="border-r text-sm text-green-600">
                  Create Data Count
                </div>
                <div className="border-r text-sm text-green-600">
                  Update Data Count
                </div>
                <div className="text-sm text-blue-500">Elapsed Time</div>
              </div>
              <div className="flex p-1 text-black">
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.created_data_count}
                </div>
                <div className="border-r text-sm text-center w-[50%]">
                  {successData2?.updated_data_count}
                </div>
                <div className=" text-[12px] text-right w-[50%]">
                  {successData2?.elapsed_time}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreDataMapping;
